module.exports = __webpack_public_path__ + "static/media/tools-zoom-mode-prev.7d2564c5.svg";